<template>
  <div align="center" class="on-secondary">
    <h1 class="my-15">
      {{ t(`app.notRight.${pageInUse}.title`) }}
    </h1>
    <v-img
      v-if="pageInUse === '404'"
      src="@/assets/img/searching-yeti.png"
      width="200px"
      class="mx-auto d-block"
    />
    <v-img v-else src="@/assets/img/yeti-not-right.png" width="200px" class="mx-auto d-block" />
    <p class="my-15 font-italic">
      {{ t(`app.notRight.${pageInUse}.message`) }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

const { t } = useI18n();
const pageInUse = ref("generic");

onBeforeMount(() => {
  switch (useRoute().name) {
    case "404":
      pageInUse.value = "404";
      break;
  }
});
</script>
